module.exports = __webpack_public_path__ + "img/em-energymonitor-studies-02.b64ef19d.webp";